import React, { Component, Requireable } from 'react';
import styled, { css } from 'styled-components';
import PropTypes, { oneOf } from 'prop-types';

export const buttonStyle = css`
  font-size: 1.2rem;
  font-weight: var(--font-weight-medium);
  color: white;
  background-color: var(--color-rojo);
  padding: 12px 22px;
  border-radius: 4px;
  transition: var(--base-transition);
  border: 0;
  cursor: pointer;
 
  &.important{
    background-color: var(--color-rojo);
    &:hover, &:focus {
    background-color: var(--color-azul);
    color:#ffffff;
    }
  }

  &.red-btn{
    background-color: var(--color-rojo);
    width:inherit;
    &:hover, &:focus {
    background-color: var(--color-azul);
    color:#ffffff;
    }
  }

  &.blue-btn{
    background-color: var(--color-azul);
    width:inherit;
    &:hover, &:focus {
      background-color: var(--color-rojo);
    color:#ffffff;
    }
  }
  &:hover, &:focus {
    background-color: var(--color-secondary-btn);
  }
  &:focus {
    outline: none;
  }
  &:disabled{
    &:hover{
      background-color: var(--color-gray-regular);
    }
    background-color: var(--color-gray-regular);
    cursor: not-allowed;
  }
  &.rounded {
    border-radius: 9999px;
  }
  &.with-icon {
    padding: 10px 24px 14px 24px;
    &::before {
      content: '';
      display: inline-block;
      position: relative;
      bottom: -3px;
      width: 22px;
      height: 22px;
      background-size: contain;
      background-repeat: no-repeat;
      filter: var(--filter-white);
      margin-right: 12px;
    }
  }
  &.with-icon::before {
    background-image: url(${props => props.icon});
  }
`

const Button = styled.button`
  ${buttonStyle}
`
interface props{
  icon?: string;
  className?: string;
  href?: string;
}

const Component = (props:props) => {
    let classes = ['myClass'];

    classes.push('btn');

    if (props.icon !== undefined) {
        classes.push('with-icon');
    }

    if (props.className) {
        classes.push(props.className);
    }

    const className = classes.join(' ');

    return (
        <Button {...props} href={props.href} className={className}>{props.children}</Button>
    )
}

export default Component;
